'use strict';
var BASWebServices;
(function (BASWebServices) {
    var LabelTypeDetector = (function () {
        function LabelTypeDetector() {
        }
        LabelTypeDetector.Factory = function () {
            return function (input) {
                if (angular.isArray(input)) {
                    var filtered = [];
                    angular.forEach(input, function (url) {
                        filtered.push(LabelTypeDetector.estimateLabelType(url));
                    });
                    return filtered;
                }
                else if (angular.isString(input)) {
                    return LabelTypeDetector.estimateLabelType(input);
                }
                else if (input === 'undefined') {
                    return 0;
                }
                else {
                    return input;
                }
            };
        };
        LabelTypeDetector.estimateLabelType = function (filename) {
            if (filename.lastIndexOf("_annot.json") != -1) {
                return "annotJSON";
            }
            else {
                return "TEXTGRID";
            }
        };
        return LabelTypeDetector;
    }());
    BASWebServices.LabelTypeDetector = LabelTypeDetector;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=LabelTypeDetector.js.map